import { render, staticRenderFns } from "./business-push-message.vue?vue&type=template&id=4d14337c&scoped=true"
import script from "./business-push-message.vue?vue&type=script&lang=js"
export * from "./business-push-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d14337c",
  null
  
)

export default component.exports